module.exports = __webpack_public_path__ + "static/media/pattern.01083a11.jpg";